var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.52,7.49l7-7,6.94,7L13.28,8.62,8.38,3.73V50.52l-1.78,0V3.74L1.71,8.64Z","transform":"translate(-0.52 -0.51)"}));
}

ArrowUp.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 13.92 50"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
